import React from 'react';
import { sharedPluginStateHookMigratorFactory, useSharedPluginState, useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { CornerControls } from './CornerControls/ClassicCornerControls';
import { RowControls } from './RowControls/ClassicControls';
var useSharedState = sharedPluginStateHookMigratorFactory(function (api) {
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['selection'], function (states) {
      var _states$selectionStat;
      return {
        selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
      };
    }),
    selection = _useSharedPluginState.selection;
  return {
    selection: selection
  };
}, function (api) {
  var _useSharedPluginState2 = useSharedPluginState(api, ['selection']),
    selectionState = _useSharedPluginState2.selectionState;
  return {
    selection: selectionState === null || selectionState === void 0 ? void 0 : selectionState.selection
  };
});
export var FloatingControlsWithSelection = function FloatingControlsWithSelection(_ref) {
  var editorView = _ref.editorView,
    tableRef = _ref.tableRef,
    isInDanger = _ref.isInDanger,
    isResizing = _ref.isResizing,
    isHeaderRowEnabled = _ref.isHeaderRowEnabled,
    isHeaderColumnEnabled = _ref.isHeaderColumnEnabled,
    hoveredRows = _ref.hoveredRows,
    stickyTop = _ref.stickyTop,
    hoverRows = _ref.hoverRows,
    selectRow = _ref.selectRow,
    tableActive = _ref.tableActive,
    api = _ref.api;
  var _useSharedState = useSharedState(api),
    selection = _useSharedState.selection;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CornerControls, {
    editorView: editorView,
    tableRef: tableRef,
    isInDanger: isInDanger,
    isResizing: isResizing,
    isHeaderRowEnabled: isHeaderRowEnabled,
    isHeaderColumnEnabled: isHeaderColumnEnabled,
    hoveredRows: hoveredRows,
    stickyTop: tableActive ? stickyTop : undefined
  }), /*#__PURE__*/React.createElement(RowControls, {
    selection: selection,
    editorView: editorView,
    tableRef: tableRef,
    hoverRows: hoverRows,
    hoveredRows: hoveredRows,
    isInDanger: isInDanger,
    isResizing: isResizing,
    selectRow: selectRow,
    stickyTop: tableActive ? stickyTop : undefined
  }));
};